var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSilver(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "15 10 77 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.6953 33.9578L34.4053 40.1378L64.7753 22.6078L54.0603 16.4228L23.6953 33.9578Z",
    fill: "#E6E6E6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.4053 40.1378L37.0453 50.8128L67.4153 33.2778L64.7753 22.6078L34.4053 40.1378Z",
    fill: "#DCDDDD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6957 33.9578L21.0557 41.5778L37.0457 50.8128L34.4057 40.1378L23.6957 33.9578Z",
    fill: "#C9CACA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M42.1758 44.6278L52.8908 50.8128L83.2558 33.2778L72.5458 27.0928L42.1758 44.6278Z",
    fill: "#E6E6E6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M52.8906 50.8128L56.1156 60.5928L85.8956 43.9478L83.2556 33.2778L52.8906 50.8128Z",
    fill: "#DCDDDD"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M42.1761 44.6278L39.5361 52.2478L56.1161 60.5928L52.8911 50.8128L42.1761 44.6278Z",
    fill: "#C9CACA"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M36.2656 28.1278L46.9806 34.3128L77.3456 16.7778L66.6356 10.5928L36.2656 28.1278Z",
    fill: "#EFEFEF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M46.9805 34.3128L49.6205 44.9828L79.9855 27.4478L77.3455 16.7778L46.9805 34.3128Z",
    fill: "#DCDDDD"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M36.266 28.1278L33.626 35.7478L49.621 44.9828L46.981 34.3128L36.266 28.1278Z",
    fill: "#C9CACA"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSilver);
export default __webpack_public_path__ + "static/media/Silver.847d0212ee47390841e9cafeea0c66d8.svg";
export { ForwardRef as ReactComponent };